import React from "react";
import "./success-field.css";


export default function SuccessField(props) {
    return(<div className="success-field mt-2">
            {props.children}
    </div>)
}